import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const TransportAgentInfoComponent = ({ transportAgents, salesOrders, vehicles, onInnerFormChange, selectedAgents }: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                    <InputContainer
                        label="RAPAgentNumber"
                        name="RAPAgentNumber"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.RAPAgentNumber',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.RAPAgentInfo?.RAPAgentNumber}
                    />
                    <InputContainer
                        label="Vehicle"
                        labelField="VehicleName"
                        list={vehicles}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.VehicleId',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                         optionName='Choose Vehicle'
                        type="select"
                        value={selectedAgents?.RAPAgentInfo?.VehicleId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="SalesOrder"
                        labelField="ShipmentPId"
                        list={salesOrders}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.SalesOrderId',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        optionName='Choose SalesOrder'
                        type="select"
                        value={selectedAgents?.RAPAgentInfo?.SalesOrderId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="RapAgent"
                        labelField="Name"
                        list={transportAgents}
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.RAPAgentId',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        optionName='Choose RapAgent'
                        type="select"
                        value={selectedAgents?.RAPAgentInfo?.RAPAgentId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="From Location"
                        name="FromLocation"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.FromLocation',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.RAPAgentInfo?.FromLocation}
                    />
                    <InputContainer
                        label="To Location"
                        name="To Location"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.ToLocation',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.RAPAgentInfo?.ToLocation}
                    />
                    <InputContainer
                        label="InvoiceNumber"
                        name="InvoiceNumber"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.InvoiceNumber',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="text"
                        value={selectedAgents?.RAPAgentInfo?.InvoiceNumber}
                    />
                    <InputContainer
                        label="TotalDistance"
                        name="TotalDistance"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.TotalDistance',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.RAPAgentInfo?.TotalDistance}
                    />
                    <InputContainer
                        label="TotalWeight"
                        name="TotalWeight"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.TotalWeight',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.RAPAgentInfo?.TotalWeight}
                    />
                    <InputContainer
                        label="TotalVolume"
                        name="TotalVolume"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.TotalVolume',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.RAPAgentInfo?.TotalVolume}
                    />
                    <InputContainer
                        label="TotalPieces"
                        name="TotalPieces"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event.target.value,
                                'RAPAgentInfo.TotalPieces',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="number"
                        value={selectedAgents?.RAPAgentInfo?.TotalPieces}
                    />
                    <InputContainer
                        label="AnyDangerousItem"
                        name="IsAnyDangerousItem"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'RAPAgentInfo.IsAnyDangerousItem',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.RAPAgentInfo?.IsAnyDangerousItem}
                    />
                    <InputContainer
                        label="Available"
                        name="IsAvailable"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'RAPAgentInfo.IsAvailable',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.RAPAgentInfo?.IsAvailable}
                    />
                    <InputContainer
                        label="CODCollectionEnabled"
                        name="IsCODCollectionEnabled"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'RAPAgentInfo.IsCODCollectionEnabled',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.RAPAgentInfo?.IsCODCollectionEnabled}
                    />
                    <InputContainer
                        label="CODCollectionLimit"
                        name="CODCollectionLimit"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'RAPAgentInfo.CODCollectionLimit',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.RAPAgentInfo?.CODCollectionLimit}
                    />
                    <InputContainer
                        label="AutoAssignJob"
                        name="IsAutoAssignJob"
                        onValueChange={(event: any) => {
                            onInnerFormChange(
                                event,
                                'RAPAgentInfo.IsAutoAssignJob',
                                selectedAgents?.RAPAgentInfo
                            )
                        }}
                        type="checkbox"
                        value={selectedAgents?.RAPAgentInfo?.IsAutoAssignJob}
                    />
                </div>
            }
            expandedPanel="rapAgentInfo"
            headerTitle="RAPAgent Info"
        />
    </>
)
export default TransportAgentInfoComponent;
